import { OptionalAxleSchema } from '@src/orders/schemas/AxleInformationInputsSchema';
import { AxleFormName } from '@src/permitField/AxleInformationFields';
import {
  TrailerDeckHeightField,
  TrailerEmptyWeightField,
  TrailerGroundClearanceField,
  TrailerHeightField,
  TrailerKingpinSetbackLengthField,
  TrailerKingpinSettingLengthField,
  TrailerLengthField,
  TrailerRegisteredWeightField,
  TrailerWheelbaseLengthField,
  TrailerWidthField,
} from '@src/permitField/TrailerDimensionFields';
import {
  TrailerLicensePlateField,
  TrailerLicensePlateStateField,
  TrailerLicensePlateTypeField,
  TrailerMakeField,
  TrailerTypeField,
  TrailerUnitNumberField,
  TrailerVINField,
  TrailerYearField,
} from '@src/permitField/TrailerInformationFields';
import * as yup from 'yup';

const schemaWithoutAxleCount = {
  [TrailerUnitNumberField.fieldName]: TrailerUnitNumberField.validator,
  [TrailerYearField.fieldName]: TrailerYearField.validator,
  [TrailerMakeField.fieldName]: TrailerMakeField.validator,
  [TrailerVINField.fieldName]: TrailerVINField.validator,
  [TrailerTypeField.fieldName]: TrailerTypeField.validator,
  [TrailerLicensePlateField.fieldName]: TrailerLicensePlateField.validator,
  [TrailerLicensePlateStateField.fieldName]:
    TrailerLicensePlateStateField.validator,
  [TrailerLicensePlateTypeField.fieldName]:
    TrailerLicensePlateTypeField.validator.notRequired(),
  [TrailerLengthField.fieldName]: TrailerLengthField.validator.notRequired(),
  [TrailerWidthField.fieldName]: TrailerWidthField.validator.notRequired(),
  [TrailerHeightField.fieldName]: TrailerHeightField.validator.notRequired(),
  [TrailerWheelbaseLengthField.fieldName]:
    TrailerWheelbaseLengthField.validator.notRequired(),
  [TrailerDeckHeightField.fieldName]:
    TrailerDeckHeightField.validator.notRequired(),
  [TrailerGroundClearanceField.fieldName]:
    TrailerGroundClearanceField.validator.notRequired(),
  [TrailerKingpinSetbackLengthField.fieldName]:
    TrailerKingpinSetbackLengthField.validator.notRequired(),
  [TrailerKingpinSettingLengthField.fieldName]:
    TrailerKingpinSettingLengthField.validator.notRequired(),
  [TrailerEmptyWeightField.fieldName]:
    TrailerEmptyWeightField.validator.notRequired(),
  [TrailerRegisteredWeightField.fieldName]:
    TrailerRegisteredWeightField.validator.notRequired(),
  [AxleFormName]: yup.array(OptionalAxleSchema).min(1).required(),
};
//This is the schema when creating a trailer
export const TrailerFormSchema = yup.object().shape(schemaWithoutAxleCount);
